<div ngModelGroup="comboTurno-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboTurno
                       nome="turno-{{data}}"
                       [itens]="dados"
                       itemDescricao="tipo"
                       itemId="flag"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Turno"
                       label="Turno"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
